import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
    {
        name: 'Index',
        path: '/index',
        alias: '/',
        component: () => import('@src/views/Index/index.vue'),
        meta: { title: '首页', whiteList: true },
    },
    {
        name: 'Workbench',
        path: '/workbench',
        component: () => import('@src/views/Workbench/index.vue'),
        meta: { title: '工作台' },
    },
    {
        name: 'Map',
        path: '/map',
        component: () => import('@src/views/Map/index.vue'),
        meta: { title: '地图' },
    },
    {
        name: 'Forbidden',
        path: '/forbidden',
        component: () => import('@src/views/Forbidden/index'),
        meta: { whiteList: true },
    },
    {
        path: '/:catchAll(.*)',
        redirect: { path: '/forbidden' },
    },
];

export const router = createRouter({
    history: createWebHistory(),
    routes,
});
